module.exports = __webpack_public_path__ + "img/home-silder1.e2eb0663.png";